<template>
  <div
    :class="{
      'col-span-12 rounded border border-www-color-neutral-very-light md:col-span-4': true,
      'hover:border hover:border-www-color-primary-lighter': true,
    }"
  >
    <div
      :class="{
        'flex h-full flex-col transition-all duration-300 ease-in-out': true,
        'cursor-pointer hover:shadow-[0_1px_10px_0_rgba(0,0,0,0.6)]': true,
        'hekate-input-selected hekate-input-highlighted': isSelected,
      }"
      :hekate-input-value="intentValue"
      hekate-input-field-name="whatIsYourIntent"
      @click="emit('select', intentValue)"
    >
      <div
        :class="{
          'h-40 overflow-hidden lg:h-80': true,
        }"
      >
        <ImageAtom
          v-bind="image"
          :loading="'eager'"
          :class="{
            'px-0': true,
          }"
        />
      </div>
      <div
        :class="{
          'card-body relative flex-grow px-10px py-15px text-center text-www-color-neutral-medium-dark lg:px-0 lg:py-45px': true,
        }"
      >
        <h4
          :class="{
            'mb-0 text-base font-bold leading-7 lg:mb-4 lg:text-22px': true,
          }"
        >
          {{ title }}
        </h4>
        <p
          :class="{
            'mb-4 text-xs lg:text-15px lg:leading-7': true,
          }"
        >
          <span>{{ description }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import ImageAtom from '~/components/Atmos/ImageAtom/ImageAtom.vue';
import type { UssIntentCards } from '~/sanity/types';

defineProps<UssIntentCards & { isSelected?: boolean }>();
const emit = defineEmits<{ select: [value: string] }>();
</script>

<style></style>
